<template>
  <div class="card">
    <div class="card-body">
      <div class="alert alert-danger" v-if="errorMessage">
        {{errorMessage}}
      </div>
      <b-form-group id="fileInput" class="dragdrop" v-if="!data.success">
        <b-form-file 
        accept=".docx, .pdf, .doc"
        v-model="file" :placeholder="$t('common.upload_resume.steps.step1.drag_title')"></b-form-file>
      </b-form-group>

      <div class="alert alert-success text-center" v-if="data.success">
        Successfully Uploaded!
      </div>
      
    </div>
  </div>
</template>


<script>
import { mapActions } from 'vuex'
import NProgress from 'nprogress/nprogress'

export default {
  data(){
    return {
      file:null,
      data:{},
      errorMessage:''
    }
  },
  methods: {
    ...mapActions('user', ['prospectParseCV']),
    reset(){
      this.data = {}
    },
    async validate() {
      var isValid = false
      this.errorMessage = ''

      if(!this.data.success){
        var formData = new FormData();
        formData.append("file", this.file);
        formData.append("type", 'candidate');
        formData.append("_id", this.user._id);
        formData.append("job_id", this.$route.query.id)
        formData.append("submission", true);
        NProgress.start()
        await this.prospectParseCV(formData).then(res => {
          if(res.data.success){
            this.data = res.data
            isValid = true
          }else{
            this.errorMessage = res.data.errorMessage
          }
          NProgress.done()
        }).catch(err => {
          this.errorMessage = err.response.data.errorMessage
          NProgress.done()
        })
      }else{
        isValid = true
      }
      
      this.$emit('on-validate', this.data, isValid)
      return isValid
    },
  }
}
</script>

<style lang="scss">


#fileInput.dragdrop .custom-file,
#fileInput.dragdrop .custom-file-input {
  height: 150px;
  cursor: pointer;
}

#fileInput.dragdrop .custom-file-label {
  border: 0;
  border: 2px dashed #404040;
  /* height: 150px; */
  /* padding: 50px; */
  /* line-height: 142px; */
  text-align: center;
  color: #404040;
  padding-top: 65px;
  padding-bottom: 90px;
}

#fileInput.dragdrop .custom-file:hover .custom-file-label {
  background: #404040;
  color: #fff;
}

#fileInput.dragdrop .custom-file-label::after {
  display: none;
}

</style>